import React, { useEffect } from 'react';
import { Login as LogIn } from '@ctsu/loader';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { text } from './common/Text';
import DocumentTitle from './common/DocumentTitle';
import { usePrevLocation } from '../Hooks';
import About from './common/About';
import { DEFAULT_REQUEST, LOGIN_PATH } from 'routes/constants';
import { setItemValueToStorage } from 'helper/utils';

export default function Login() {
  const location = useLocation();
  const referrer = location?.state?.referrer?.pathname;
  const referrerLoginValue =
    referrer && referrer !== DEFAULT_REQUEST ? referrer : '';
  setItemValueToStorage('referrerLogin', referrerLoginValue);
  return (
    <>
      <DocumentTitle title="Login Page" />
      <div className="app-body-main">
        <div className="app-body-center">
          <div
            className="row col-10 p-4 bg-white shadow-sm align-items-center"
            style={{ margin: 'auto' }}
          >
            <div className="col-6 mr-4">
              <div className="app-welcome-title color-blue">
                {text('login.welcome')}
              </div>
              <About />
            </div>
            <div className="col-6 align-center ctep-login-wrapper">
              <div>
                <div className="content-page-title color-dark-blue">
                  {text('login.ctep_iam_login')}
                </div>
                <LogIn
                  page={<Navigate to={DEFAULT_REQUEST} />}
                  height="400px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export function GotoLogin() {
  const location = useLocation();
  const currentLocation = usePrevLocation(location);
  const navigate = useNavigate();
  useEffect(() => {
    navigate(LOGIN_PATH, { state: { referrer: currentLocation } });
  }, []);
  return <></>;
}
